import { Icon } from '@iconify/react'
import { useCallback, useState, type KeyboardEvent, type ReactNode } from 'react'

import styles from './payments-section.module.scss'

type Props = {
  title: string
  children: ReactNode
  defaultOpen?: boolean
}

export const PaymentsSection = ({ title, children, defaultOpen = false }: Props) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const toggleOpen = useCallback(() => setIsOpen((prev) => !prev), [])

  const handleHeaderKey = useCallback(
    (event: KeyboardEvent<HTMLDivElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        toggleOpen()
      }
    },
    [toggleOpen],
  )

  return (
    <section className={styles.panel}>
      <div
        className={`${styles.header} ${isOpen ? '' : styles.headerCollapsed}`}
        onClick={toggleOpen}
        onKeyDown={handleHeaderKey}
        role='button'
        tabIndex={0}
        aria-expanded={isOpen}>
        <span>{title}</span>
        <Icon icon={isOpen ? 'ph:caret-down' : 'ph:caret-right'} />
      </div>
      {isOpen && <div className={styles.body}>{children}</div>}
    </section>
  )
}
